/* MichanDirect 2.1 – feature layer: popup, age gate, back to top, infinite scroll,
   recently viewed, gift options, sticky add to cart, pre-order / back in stock,
   stock counter, dialogs, countdown, hotspots, before/after, FAQ search. */
(function () {
  'use strict';
  var cfg = window.mdTheme || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var design = !!(window.Shopify && Shopify.designMode);
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var LS = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Focus trap helper ---------- */
  function trap(container, e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),textarea,select,[tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var b = $('#MdBackToTop');
    if (!b || b.dataset.bound) return;
    b.dataset.bound = '1';
    var on = false;
    function upd() {
      var s = window.scrollY > 700;
      if (s !== on) { on = s; b.classList.toggle('is-visible', s); }
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var main = $('#MainContent');
      if (main) { main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
    });
  }

  /* ---------- Promo popup ---------- */
  var popupLastFocus = null;
  function openPopup(p) {
    if (!p || !p.hidden) return;
    popupLastFocus = document.activeElement;
    p.hidden = false;
    requestAnimationFrame(function () { p.classList.add('is-open'); });
    document.documentElement.classList.add('md-lock');
    var c = $('.md-popup__close', p);
    if (c) c.focus();
  }
  function closePopup(p) {
    if (!p || p.hidden) return;
    p.classList.remove('is-open');
    document.documentElement.classList.remove('md-lock');
    setTimeout(function () { p.hidden = true; }, reduce ? 0 : 300);
    if (popupLastFocus && popupLastFocus.focus) popupLastFocus.focus();
  }
  function initPopup() {
    var p = $('#MdPopup');
    if (!p || p.dataset.bound) return;
    p.dataset.bound = '1';
    p.addEventListener('click', function (e) {
      if (e.target.closest('[data-md-close]')) closePopup(p);
      var copy = e.target.closest('[data-md-copy]');
      if (copy) {
        var code = copy.getAttribute('data-md-copy');
        var done = function () { copy.textContent = copy.getAttribute('data-copied') || 'Copied'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      }
    });
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup(p);
      trap($('.md-popup__panel', p), e);
    });
    if (design) return;
    if (p.hasAttribute('data-open-now') && /MdPopup/.test(window.location.hash)) { openPopup(p); return; }
    var key = p.dataset.key, days = parseFloat(p.dataset.days || '7');
    var last = LS.get(key, 0);
    if (last && Date.now() - last < days * 864e5) return;
    var pages = LS.get('md-pv', 0) + 1;
    LS.set('md-pv', pages);
    if (pages < parseInt(p.dataset.minPages || '1', 10)) return;
    var shown = false;
    function show() {
      if (shown) return;
      var busy = document.documentElement.classList.contains('md-age-lock') ||
        $('cart-drawer.active') || $('.menu-drawer-container[open]') || $('quick-add-modal[open]') || $('.md-satc.is-visible:hover');
      if (busy) { setTimeout(show, 6000); return; }
      shown = true;
      LS.set(key, Date.now());
      openPopup(p);
    }
    var delay = parseInt(p.dataset.delay || '-1', 10);
    if (delay >= 0) setTimeout(show, delay * 1000);
    if (p.dataset.exit === 'true') {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
    }
  }

  /* ---------- Age verifier ---------- */
  function initAge() {
    var a = $('#MdAge');
    if (!a || a.dataset.bound) return;
    a.dataset.bound = '1';
    var key = 'md-age-ok', days = parseFloat(a.dataset.days || '30');
    a.addEventListener('click', function (e) {
      if (e.target.closest('[data-md-age-yes]')) {
        LS.set(key, Date.now());
        a.hidden = true;
        document.documentElement.classList.remove('md-age-lock');
      } else if (e.target.closest('[data-md-age-no]')) {
        var url = a.dataset.decline;
        if (url) window.location.href = url; else if (history.length > 1) history.back(); else window.location.href = 'https://www.google.com';
      }
    });
    a.addEventListener('keydown', function (e) { trap(a, e); });
    if (!a.hidden) { var y = $('[data-md-age-yes]', a); if (y) y.focus(); }
    var ok = LS.get(key, 0);
    if (ok && Date.now() - ok < days * 864e5 && !design) { a.hidden = true; document.documentElement.classList.remove('md-age-lock'); }
  }

  /* ---------- Infinite scroll on collection / search grids ---------- */
  function initInfinite() {
    if (!cfg.infiniteScroll) return;
    var container = $('#ProductGridContainer');
    if (!container) return;
    var autoLoads = 0, loading = false, io = null;
    function setup() {
      var grid = $('#product-grid', container);
      var wrap = $('.pagination-wrapper', container);
      if (!grid || !wrap || $('.md-loadmore', container)) return;
      var next = $('a.pagination__item--prev', wrap);
      container.classList.add('md-infinite');
      var box = document.createElement('div');
      box.className = 'md-loadmore';
      box.innerHTML = '<button type="button" class="button button--secondary">' + esc(cfg.strings.loadMore) + '</button><p class="md-loadmore__status" role="status" aria-live="polite"></p>';
      wrap.parentNode.insertBefore(box, wrap.nextSibling);
      var btn = $('button', box), status = $('.md-loadmore__status', box);
      var nextUrl = next ? next.href : null;
      if (!nextUrl) { box.classList.add('is-done'); return; }
      function load() {
        if (loading || !nextUrl) return;
        loading = true;
        btn.setAttribute('aria-busy', 'true');
        status.textContent = cfg.strings.loading;
        fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = $$('#product-grid > li', doc);
          items.forEach(function (li) {
            $$('.scroll-trigger', li).forEach(function (el) { el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in'); });
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            grid.appendChild(document.importNode(li, true));
          });
          var n = $('#ProductGridContainer .pagination-wrapper a.pagination__item--prev', doc);
          nextUrl = n ? n.href : null;
          status.textContent = cfg.strings.loaded.replace('{count}', items.length);
          if (!nextUrl) { box.classList.add('is-done'); status.textContent = cfg.strings.allLoaded; if (io) io.disconnect(); }
        }).catch(function () { status.textContent = ''; })
          .finally(function () { loading = false; btn.removeAttribute('aria-busy'); });
      }
      btn.addEventListener('click', function () { autoLoads = 0; load(); });
      if ('IntersectionObserver' in window) {
        if (io) io.disconnect();
        io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && autoLoads < 3) { autoLoads++; load(); }
        }, { rootMargin: '600px 0px' });
        io.observe(box);
      }
    }
    setup();
    new MutationObserver(function () { if (!$('.md-loadmore', container)) { autoLoads = 0; setup(); } })
      .observe(container, { childList: true });
  }

  /* ---------- Recently viewed ---------- */
  function trackRecentlyViewed() {
    var h = cfg.productHandle;
    if (!h) return;
    var list = LS.get('md-rv', []).filter(function (x) { return x !== h; });
    list.unshift(h);
    LS.set('md-rv', list.slice(0, 16));
  }
  function initRecentlyViewed(scope) {
    $$('[data-md-rv]', scope).forEach(function (sec) {
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var limit = parseInt(sec.dataset.limit || '4', 10);
      var current = cfg.productHandle;
      var list = LS.get('md-rv', []).filter(function (h) { return h !== current; }).slice(0, limit);
      var ul = $('ul', sec);
      if (!list.length || !ul) return;
      Promise.all(list.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=md-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            if (!t) { LS.set('md-rv', LS.get('md-rv', []).filter(function (x) { return x !== h; })); return ''; }
            var d = new DOMParser().parseFromString(t, 'text/html');
            var li = $('li.grid__item', d);
            return li ? li.outerHTML : '';
          }).catch(function () { return ''; });
      })).then(function (cards) {
        var html = cards.join('');
        if (!html) return;
        ul.innerHTML = html;
        sec.hidden = false;
      });
    });
  }

  /* ---------- Cart gift options ---------- */
  var gift = cfg.gift || {};
  var cartState = null;
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; });
  }
  function giftMarkup(uid) {
    var g = gift;
    var wrap = g.wrapVariantId ? '<label class="md-gift__wrap"><input type="checkbox" data-md-gift-wrap> <span>' + esc(g.wrapLabel) + '</span></label>' : '';
    return '<div class="md-gift" data-md-gift>' +
      '<label class="md-gift__toggle"><input type="checkbox" data-md-gift-check> <span>' + esc(g.heading) + '</span></label>' +
      '<div class="md-gift__body" hidden>' +
      '<label for="MdGiftMsg-' + uid + '" class="visually-hidden">' + esc(g.messageLabel) + '</label>' +
      '<textarea id="MdGiftMsg-' + uid + '" maxlength="' + (g.max || 250) + '" placeholder="' + esc(g.placeholder) + '" data-md-gift-msg></textarea>' +
      '<div class="md-gift__meta"><span data-md-gift-saved></span><span><span data-md-gift-count>0</span>/' + (g.max || 250) + '</span></div>' +
      wrap + (g.note ? '<p class="md-gift__meta" style="justify-content:flex-start">' + esc(g.note) + '</p>' : '') +
      '</div></div>';
  }
  function bindGift(box, onCartPage) {
    var check = $('[data-md-gift-check]', box), body = $('.md-gift__body', box), msg = $('[data-md-gift-msg]', box),
      count = $('[data-md-gift-count]', box), saved = $('[data-md-gift-saved]', box), wrap = $('[data-md-gift-wrap]', box);
    ['change', 'input'].forEach(function (t) { box.addEventListener(t, function (e) { e.stopPropagation(); }); });
    function apply(c) {
      var attrs = (c && c.attributes) || {};
      var isGift = attrs.Gift === 'Yes';
      check.checked = isGift;
      body.hidden = !isGift;
      msg.value = attrs['Gift message'] || '';
      count.textContent = msg.value.length;
      if (wrap) wrap.checked = !!(c && c.items.some(function (i) { return String(i.variant_id) === String(gift.wrapVariantId); }));
    }
    if (cartState) apply(cartState);
    getCart().then(apply);
    function saveAttrs(a) {
      saved.textContent = gift.saving || 'Saving…';
      return postJSON(root + 'cart/update.js', { attributes: a }).then(function (c) { cartState = c; saved.textContent = gift.saved || 'Saved'; });
    }
    check.addEventListener('change', function () {
      body.hidden = !check.checked;
      saveAttrs(check.checked ? { Gift: 'Yes', 'Gift message': msg.value } : { Gift: '', 'Gift message': '' });
      if (check.checked) msg.focus();
    });
    msg.addEventListener('input', function () { count.textContent = msg.value.length; });
    msg.addEventListener('input', debounce(function () { saveAttrs({ Gift: 'Yes', 'Gift message': msg.value }); }, 700));
    if (wrap) {
      wrap.addEventListener('change', function () {
        var drawer = $('cart-drawer');
        var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
        var req;
        if (wrap.checked) {
          req = postJSON(root + 'cart/add.js', { items: [{ id: gift.wrapVariantId, quantity: 1 }], sections: sections, sections_url: window.location.pathname });
        } else {
          var line = cartState && cartState.items.filter(function (i) { return String(i.variant_id) === String(gift.wrapVariantId); })[0];
          if (!line) return;
          req = postJSON(root + 'cart/change.js', { id: line.key, quantity: 0, sections: sections, sections_url: window.location.pathname });
        }
        req.then(function (res) {
          if (onCartPage || !drawer || !res.sections) { window.location.reload(); return; }
          drawer.renderContents(res);
        });
      });
    }
  }
  function injectGift() {
    if (!gift.enabled) return;
    var drawerFooter = $('#CartDrawer .drawer__footer');
    if (drawerFooter && !$('[data-md-gift]', drawerFooter)) {
      drawerFooter.insertAdjacentHTML('afterbegin', giftMarkup('drawer'));
      bindGift($('[data-md-gift]', drawerFooter), false);
    }
    var pageWrap = $('#main-cart-footer');
    var pageFooter = pageWrap && $('.cart__footer', pageWrap);
    if (pageFooter && !$('[data-md-gift]', pageWrap)) {
      pageFooter.insertAdjacentHTML('beforebegin', giftMarkup('page'));
      var box = $('[data-md-gift]', pageWrap);
      box.classList.add('md-gift--page');
      bindGift(box, true);
    }
  }
  function initGift() {
    if (!gift.enabled) return;
    injectGift();
    var drawer = $('cart-drawer');
    if (drawer) new MutationObserver(debounce(injectGift, 50)).observe(drawer, { childList: true, subtree: true });
    var cf = $('#main-cart-footer');
    if (cf) new MutationObserver(debounce(injectGift, 50)).observe(cf, { childList: true, subtree: true });
  }

  /* ---------- Product page: variant-aware pre-order, back in stock, stock counter ---------- */
  function variantData(sid) {
    var el = document.querySelector('script[data-md-variants="' + sid + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function currentVariantId(sid) {
    var input = $('#product-form-' + sid + ' input[name="id"]') || $('[data-section-id="' + sid + '"] form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? input.value : null;
  }
  function applyVariantState(sid, vid) {
    var data = variantData(sid);
    if (!data) return;
    var v = data.v[vid];
    var btn = document.getElementById('ProductSubmitButton-' + sid);
    var pre = !!(v && v.p && v.a);
    // Pre-order label + property
    if (btn && data.pre) {
      var span = $('span', btn);
      if (pre && span && span.textContent.trim() !== data.s.preorder) span.textContent = data.s.preorder;
      $$('[data-md-preorder-prop="' + sid + '"]').forEach(function (i) { i.disabled = !pre; });
      $$('[data-md-preorder-note="' + sid + '"]').forEach(function (n) { n.hidden = !pre; });
    }
    // Back in stock form
    $$('[data-md-bis="' + sid + '"]').forEach(function (b) {
      b.hidden = !v || !!v.a;
      var vi = $('[data-md-bis-variant]', b);
      if (vi && v) vi.value = v.t;
    });
    // Stock counter
    $$('[data-md-stock="' + sid + '"]').forEach(function (s) {
      var th = parseInt(s.dataset.threshold || '10', 10);
      var q = v && typeof v.q === 'number' ? v.q : null;
      if (q === null || q <= 0 || !v.a) { s.hidden = true; return; }
      s.hidden = false;
      var low = q <= th;
      s.classList.toggle('is-low', low);
      var txt = $('[data-md-stock-text]', s);
      if (txt) txt.textContent = (low ? data.s.low : data.s.inStock).replace('{count}', q);
      var bar = $('[data-md-stock-bar]', s);
      if (bar) { bar.parentNode.hidden = !low; bar.style.width = Math.max(8, Math.min(100, q / th * 100)) + '%'; }
    });
  }
  function initVariantFeatures() {
    $$('script[data-md-variants]').forEach(function (el) {
      var sid = el.getAttribute('data-md-variants');
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      applyVariantState(sid, currentVariantId(sid));
      var btn = document.getElementById('ProductSubmitButton-' + sid);
      if (btn) {
        new MutationObserver(function () { applyVariantState(sid, currentVariantId(sid)); })
          .observe(btn, { childList: true, subtree: true, characterData: true });
      }
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !initVariantFeatures.sub) {
      initVariantFeatures.sub = true;
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var d = ev && ev.data;
        if (!d) return;
        setTimeout(function () { applyVariantState(d.sectionId, d.variant ? String(d.variant.id) : null); }, 0);
      });
    }
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc() {
    $$('[data-md-satc]').forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      var sid = bar.dataset.mdSatc;
      var main = document.getElementById('ProductSubmitButton-' + sid);
      if (bar.closest('quick-add-modal')) return;
      $$('body > [data-md-satc="' + sid + '"]').forEach(function (o) { if (o !== bar) o.remove(); });
      document.body.appendChild(bar);
      var btn = $('[data-md-satc-btn]', bar), price = $('[data-md-satc-price]', bar);
      if (!main || !btn) return;
      function sync() {
        var s = $('span', main);
        btn.textContent = s ? s.textContent.trim() : main.textContent.trim();
        btn.disabled = main.disabled;
        var p = document.getElementById('price-' + sid);
        if (p && price) {
          var sale = $('.price--on-sale', p);
          var el = sale ? $('.price__sale .price-item--last', p) : $('.price__regular .price-item--regular', p);
          if (el) price.textContent = el.textContent.trim();
        }
      }
      sync();
      new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
      var pw = document.getElementById('price-' + sid);
      if (pw) new MutationObserver(sync).observe(pw, { childList: true, subtree: true, characterData: true });
      btn.addEventListener('click', function () {
        if (main.disabled) { main.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
        main.click();
      });
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) {
        var e = en[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.hidden = false;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('md-satc-on', show);
      }).observe(main);
    });
  }

  /* ---------- Generic dialogs (size chart etc.) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-md-dialog-open]');
    if (o) {
      var d = document.getElementById(o.getAttribute('data-md-dialog-open'));
      if (d && d.showModal) { d.showModal(); }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-md-dialog-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('md-dialog')) e.target.close();
  });

  /* ---------- Countdown ---------- */
  function initCountdown(scope) {
    $$('[data-md-countdown]', scope).forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var end = Date.parse(el.dataset.mdCountdown);
      if (isNaN(end)) return;
      var units = { d: $('[data-u=d]', el), h: $('[data-u=h]', el), m: $('[data-u=m]', el), s: $('[data-u=s]', el) };
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) {
          clearInterval(timer);
          var sec = el.closest('.shopify-section');
          if (el.dataset.hideOnEnd === 'true' && sec && !design) sec.hidden = true;
          else { var done = $('[data-md-cd-done]', el); if (done) done.hidden = false; var g = $('.md-cd__grid', el); if (g) g.hidden = true; }
          return;
        }
        var t = Math.floor(ms / 1000);
        if (units.d) units.d.textContent = Math.floor(t / 86400);
        if (units.h) units.h.textContent = String(Math.floor(t % 86400 / 3600)).padStart(2, '0');
        if (units.m) units.m.textContent = String(Math.floor(t % 3600 / 60)).padStart(2, '0');
        if (units.s) units.s.textContent = String(t % 60).padStart(2, '0');
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Hotspots ---------- */
  document.addEventListener('click', function (e) {
    var pin = e.target.closest && e.target.closest('.md-hs__pin');
    $$('.md-hs__pin[aria-expanded=true]').forEach(function (p) {
      if (p === pin) return;
      p.setAttribute('aria-expanded', 'false');
      var c = document.getElementById(p.getAttribute('aria-controls')); if (c) c.hidden = true;
    });
    if (!pin) return;
    var open = pin.getAttribute('aria-expanded') !== 'true';
    pin.setAttribute('aria-expanded', open ? 'true' : 'false');
    var card = document.getElementById(pin.getAttribute('aria-controls'));
    if (card) card.hidden = !open;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.md-hs__pin[aria-expanded=true]').forEach(function (p) { p.click(); });
  });

  /* ---------- Before / after ---------- */
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-md-ba]')) return;
    e.target.closest('.md-ba').style.setProperty('--pos', e.target.value + '%');
  });

  /* ---------- FAQ search ---------- */
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-md-faq-search]')) return;
    var q = e.target.value.trim().toLowerCase();
    var wrap = e.target.closest('.md-faq');
    var any = false;
    $$('.md-faq__group', wrap).forEach(function (g) {
      var vis = 0;
      $$('details', g).forEach(function (d) {
        var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1;
        d.hidden = !hit;
        if (hit) vis++;
        if (q && hit) d.open = true; else if (!q) d.open = false;
      });
      g.hidden = vis === 0;
      if (vis) any = true;
    });
    var empty = $('.md-faq__empty', wrap);
    if (empty) empty.hidden = any;
  });

  /* ---------- Init ---------- */
  function init(scope) {
    initBackToTop();
    initPopup();
    initAge();
    initRecentlyViewed(scope);
    initVariantFeatures();
    initStickyAtc();
    initCountdown(scope);
  }
  trackRecentlyViewed();
  function boot() { init(); initInfinite(); initGift(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector && e.target.querySelector('#MdPopup');
    if (p && e.target.querySelector('[data-md-preview="popup"]')) openPopup(p);
    var a = e.target.querySelector && e.target.querySelector('#MdAge[data-md-preview="age"]');
    if (a) a.hidden = false;
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector && e.target.querySelector('#MdPopup');
    if (p) closePopup(p);
    var a = e.target.querySelector && e.target.querySelector('#MdAge');
    if (a && design) a.hidden = true;
  });
})();
